import type { ImportedTableData } from '../data/import/tabularImport';
import type { TableSourceDescriptor } from '../data/model';
import type { ProjectIdFactory } from './createImportedVectorLayer';

const createProjectId: ProjectIdFactory = (prefix) => `${prefix}_${crypto.randomUUID()}`;

export function createImportedTableSource(
  imported: ImportedTableData,
  createId: ProjectIdFactory = createProjectId,
): TableSourceDescriptor {
  return {
    id: createId('src'),
    name: imported.suggestedTableName,
    kind: 'table',
    fields: imported.fields,
    rows: imported.rows,
    rowCount: imported.rows.length,
    provenance: imported.provenance,
    warnings: imported.warnings,
  };
}
